import React from "react";

import DefaultToolbar from "./DefaultToolbar";
import SmallToolbar from "./SmallToolbar";

export default function Toolbar({ small, editor}) {
  return small ? <SmallToolbar editor={editor} /> : <DefaultToolbar editor={editor} />
}